var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.993 5.64351C11.993 6.55873 11.2511 7.30067 10.3358 7.30067C9.42061 7.30067 8.67868 6.55873 8.67868 5.64351C8.67868 4.72828 9.42061 3.98635 10.3358 3.98635C11.2511 3.98635 11.993 4.72828 11.993 5.64351Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4783 5.6716C14.4783 7.9757 12.6028 9.84319 10.289 9.84319L10.2899 9.84408C9.86744 9.84408 8.90674 9.74686 8.43832 9.35798L7.85412 9.94041C7.36714 10.4247 7.7569 10.4247 7.95134 10.8136C7.95134 10.8136 8.43832 11.4924 7.95134 12.1712C7.65968 12.56 6.84127 13.1027 5.90531 12.1712L5.71087 12.3656C5.71087 12.3656 6.29596 13.0452 5.80809 13.724C5.51644 14.112 4.73691 14.5 4.05461 13.8212L3.37319 14.5L1.52246 14.3436L1.52249 12.56L6.58762 7.51523C6.58762 7.51523 6.10064 6.73924 6.10064 5.6716C6.10064 3.3675 7.97609 1.5 10.289 1.5C12.6028 1.5 14.4783 3.3675 14.4783 5.6716Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.93de2c2348a0fd1e5b280ff35071e2e2.svg";
export { ForwardRef as ReactComponent };